import ReactGA from 'react-ga4';
import snakeCase from 'snakecase-keys';
import * as cevents from 'up.lib.js.cevents';

type TrackingEvent = {
  action: string;
  category: string;
  label: string;
};

type GoogleAnalyticsEvent = {
  nonInteraction?: boolean;
  value: any;
} & TrackingEvent;

type CEvent = {
  metadata?: any;
} & TrackingEvent;

export const trackGoogleAnalyticsEvent = (event: GoogleAnalyticsEvent) => {
  if (ReactGA.isInitialized) {
    const { category, action, label, value, nonInteraction = false } = event;
    ReactGA.event({
      category,
      action,
      label,
      value,
      nonInteraction,
    });
  }
};

export const trackCEvent = (event: CEvent) => {
  const metadata = snakeCase(event.metadata || {});
  cevents.setLevel('debug');
  cevents.debugRaw(event.category, event.action, event.label, metadata);
};

export const trackEvent = (
  category: string,
  action: string,
  label: string,
  data?: any
) => {
  trackGoogleAnalyticsEvent({
    category,
    action,
    label,
    value: 1,
  });
  trackCEvent({
    category,
    action,
    label,
    metadata: data,
  });
};

export const trackPage = (page: string) => {
  if (ReactGA.isInitialized) {
    ReactGA.set({
      page,
    });
    ReactGA.send('pageview');
  }
};
